"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.mapNumberFieldProperties = exports.onChangeNumberField = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _react = _interopRequireDefault(require("react"));

var _reactLoadable = _interopRequireDefault(require("react-loadable"));

var _FormLabel = _interopRequireDefault(require("../../FormLabel"));

var _Loader = _interopRequireDefault(require("../../Loader"));

var _Validations = require("../../Validations");

var _FieldMapper = _interopRequireWildcard3(require("./FieldMapper"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var LoadableCurrencyInput = (0, _reactLoadable.default)({
  loader: function loader() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("../../CurrencyInput"));
    }).then(_FieldMapper.enhance);
  },
  render: _FieldMapper.attachComponentToFormLoadableRender,
  loading: function loading() {
    return /*#__PURE__*/_react.default.createElement(_Loader.default, null);
  }
});
var LoadableTextInput = (0, _reactLoadable.default)({
  loader: function loader() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("../../TextInput"));
    }).then(_FieldMapper.enhance);
  },
  render: _FieldMapper.attachComponentToFormLoadableRender,
  loading: function loading() {
    return /*#__PURE__*/_react.default.createElement(_Loader.default, null);
  }
});
var LoadableDropdown = (0, _reactLoadable.default)({
  loader: function loader() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("../../DropDown"));
    }).then(_FieldMapper.enhance);
  },
  render: _FieldMapper.attachComponentToFormLoadableRender,
  loading: function loading() {
    return /*#__PURE__*/_react.default.createElement(_Loader.default, null);
  }
});
var LoadableRadioButtonGroup = (0, _reactLoadable.default)({
  loader: function loader() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("../../RadioGroup"));
    }).then(_FieldMapper.enhance);
  },
  render: _FieldMapper.attachComponentToFormLoadableRender,
  loading: function loading() {
    return /*#__PURE__*/_react.default.createElement(_Loader.default, null);
  }
});
var LoadableStars = (0, _reactLoadable.default)({
  loader: function loader() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("../../Stars"));
    }).then(_FieldMapper.enhance);
  },
  render: _FieldMapper.attachComponentToFormLoadableRender,
  loading: function loading() {
    return /*#__PURE__*/_react.default.createElement(_Loader.default, null);
  }
});
var LoadableTypography = (0, _reactLoadable.default)({
  loader: function loader() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("../../Typography"));
    }).then(_FieldMapper.enhance);
  },
  render: _FieldMapper.attachComponentToFormLoadableRender,
  loading: function loading() {
    return /*#__PURE__*/_react.default.createElement(_Loader.default, null);
  }
});

var getValidations = function getValidations(field, minValue, maxValue) {
  var validations = [];

  if (field.properties.isRequired) {
    validations.push(_Validations.requiredValidation);
  }

  if (field.properties.pattern) {
    validations.push(_Validations.regExpValidation);
  }

  if (minValue) {
    validations.push(_Validations.minValueValidation);
  }

  if (maxValue) {
    validations.push(_Validations.maxValueValidation);
  }

  return validations;
};

var mapInputProperties = function mapInputProperties(field, model) {
  var minValue, maxValue;
  minValue = parseFloat(field.properties.minValue);
  maxValue = parseFloat(field.properties.maxValue);
  minValue = isNaN(minValue) ? undefined : minValue;
  maxValue = isNaN(maxValue) ? undefined : maxValue;
  return _objectSpread(_objectSpread({}, model), {}, {
    component: LoadableTextInput,
    regExpPattern: field.properties.pattern,
    errorMessages: {
      regExpPattern: field.properties.patternMessage
    },
    minValue: minValue,
    maxValue: maxValue,
    validations: getValidations(field, minValue, maxValue),
    onlyValidateOnBlur: true,
    onChange: onChangeNumberField,
    type: "number"
  });
};

var mapMaskedInputProperties = function mapMaskedInputProperties(field, model) {
  return _objectSpread(_objectSpread({}, mapInputProperties(field, model)), {}, {
    component: LoadableCurrencyInput,
    onlyValidateOnBlur: true,
    type: "text"
  });
};

var mapDropdownProperties = function mapDropdownProperties(field, model) {
  var properties = field.properties;
  var options;

  if (properties.allowedValuesWithLabels) {
    options = (0, _FieldMapper.buildOptionsArrayWithLabels)(properties.allowedValuesWithLabels);
  } else {
    options = (0, _FieldMapper.buildOptionArray)(properties.allowedValues);
  }

  return _objectSpread(_objectSpread({}, model), {}, {
    component: LoadableDropdown,
    options: options,
    validations: getValidations(field),
    onlyValidateOnBlur: true,
    sortMenuOptions: false,
    // react-select doesn't return an event, it just returns an array of selected values.
    // So we give dropdown a unique onChange, and always return the first element because it should only have 1.
    onChange: function onChange(selected) {
      var value = selected[0];
      return value != null ? value : {
        value: null
      };
    },
    value: options.find(function (x) {
      return x.value === model.value;
    })
  });
};

var mapRadioProperties = function mapRadioProperties(field, model) {
  return _objectSpread(_objectSpread({}, model), {}, {
    name: model.id,
    component: LoadableRadioButtonGroup,
    options: (0, _FieldMapper.buildOptionArray)(field.properties.allowedValues).map(function (option) {
      return _objectSpread({
        id: "radio-option-".concat(model.id),
        name: "radio-option-".concat(model.id)
      }, option);
    }),
    validations: getValidations(field),
    onlyValidateOnBlur: true,
    onChange: function onChange(params) {
      // this is the same as the common onChange, but we need the value to be an int.
      var event = params[0];
      var value = params[1];
      var newValue = value;

      if (!newValue) {
        newValue = event.target.value;
      }

      return {
        value: parseFloat(newValue)
      };
    }
  });
};

var mapStarProperties = function mapStarProperties(field, model) {
  if (field.properties.maxValue && field.properties.maxValue > 15) {
    return _objectSpread(_objectSpread({}, model), {}, {
      component: LoadableTypography,
      children: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, model.label && /*#__PURE__*/_react.default.createElement(_FormLabel.default, {
        id: "label"
      }, model.label), "Must not have more than 15 stars"),
      disabled: true
    });
  }

  return _objectSpread(_objectSpread({}, model), {}, {
    value: !model.value || model.value === "" ? 0 : model.value,
    component: LoadableStars,
    validations: getValidations(field, field.properties.minValue, field.properties.maxValue),
    totalStars: field.properties.maxValue != null ? field.properties.maxValue : 5,
    minValue: field.properties.minValue,
    maxValue: field.properties.maxValue,
    editable: true,
    size: 24,
    useHalfStars: false,
    onChange: function onChange(newRatingArray) {
      return {
        value: newRatingArray[0]
      };
    }
  });
};

var onChangeNumberField = function onChangeNumberField(params) {
  var event = params[0];
  var value = null;

  if (params.length === 1) {
    value = event.target.value;
  } else {
    value = params[1];
  }

  var result = {
    display: "",
    value: null
  };

  if (value) {
    result.display = value;
    var parsed = parseFloat(value);
    result.value = isNaN(parsed) ? null : parsed;
  }

  return result;
};

exports.onChangeNumberField = onChangeNumberField;

var mapNumberFieldProperties = function mapNumberFieldProperties(_ref) {
  var field = _ref.field,
      htmlId = _ref.htmlId,
      display = _ref.display,
      value = _ref.value,
      onValidation = _ref.onValidation;
  var displayValue = display;

  if (value && !displayValue) {
    displayValue = value;
  }

  var model = (0, _FieldMapper.default)(field, htmlId, value, undefined, onValidation);

  switch (field.properties.editor) {
    case "Input":
      return mapInputProperties(field, model);

    case "MaskedInput":
      return mapMaskedInputProperties(field, model);

    case "Dropdown":
      return mapDropdownProperties(field, model);

    case "Radio":
      return mapRadioProperties(field, model);

    case "Stars":
      return mapStarProperties(field, model);

    default:
      return null;
  }
};

exports.mapNumberFieldProperties = mapNumberFieldProperties;
var _default = mapNumberFieldProperties;
exports.default = _default;